import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotSelected = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 259,
	height: 242,
	viewBox: "0 0 259 242",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M67.7664 183.733L197.766 217.21C206.947 219.563 216.301 214.041 218.675 204.864L257.991 52.1905C260.344 43.0092 254.82 33.655 245.644 31.281L124.702 0.136826L93.7458 13.9945L55.4203 162.824C53.067 172.006 58.5898 181.359 67.7664 183.733Z",
			fill: "#373D62"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M244.412 36.0675C250.946 37.7582 254.879 44.4192 253.204 50.958L213.888 203.631C212.197 210.166 205.536 214.099 198.998 212.423L68.9984 178.947C62.4636 177.256 58.5306 170.595 60.2066 164.057L97.9383 17.5333L125.143 5.3542L244.412 36.0675Z",
			fill: "#252941"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M94.0757 14.7817L114.195 19.9625C117.254 20.75 120.372 18.9091 121.159 15.8511L124.985 0.990799C125.035 0.799759 124.92 0.604727 124.728 0.555965C124.651 0.535925 124.568 0.542595 124.494 0.575325L94.0202 14.1091C93.8392 14.1893 93.7584 14.4003 93.8386 14.5807C93.8826 14.6802 93.9702 14.7543 94.0757 14.7817Z",
			fill: "#404772"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M104.661 145.162L163.847 160.403C165.376 160.797 166.936 159.877 167.33 158.347C167.723 156.818 166.803 155.259 165.274 154.866L106.087 139.624C104.558 139.23 102.999 140.151 102.605 141.68C102.211 143.209 103.132 144.768 104.661 145.162Z",
			fill: "#5C65A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90.8327 151.566L161.441 169.749C162.971 170.141 164.529 169.219 164.921 167.689C165.313 166.162 164.394 164.605 162.867 164.21L92.2588 146.028C90.7292 145.634 89.1701 146.555 88.7767 148.084C88.3826 149.613 89.3031 151.172 90.8327 151.566Z",
			fill: "#5C65A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M188.004 158.548C182.423 158.548 177.898 163.072 177.898 168.654C177.898 174.236 182.423 178.76 188.004 178.76C193.586 178.76 198.111 174.236 198.111 168.654C198.111 163.072 193.586 158.548 188.004 158.548Z",
			fill: "#5C65A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.954 118.713L189.559 138.947C194.29 140.16 199.108 137.314 200.33 132.587L216.804 68.5931C218.016 63.8632 215.17 59.0444 210.443 57.822L131.837 37.5878C127.107 36.3755 122.288 39.221 121.066 43.9483L104.593 107.942C103.38 112.672 106.226 117.491 110.954 118.713Z",
			fill: "#252941"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M210.183 58.83C214.355 59.9088 216.865 64.1597 215.796 68.3339L199.323 132.327C198.244 136.498 193.993 139.009 189.819 137.94L111.213 117.705C107.042 116.626 104.531 112.375 105.6 108.201L122.073 44.2081C123.152 40.0366 127.403 37.5257 131.577 38.5951L210.183 58.83ZM110.954 118.713L189.559 138.947C194.29 140.16 199.108 137.314 200.33 132.587L216.804 68.5931C218.016 63.8632 215.17 59.0444 210.443 57.822L131.837 37.5878C127.107 36.3755 122.288 39.221 121.066 43.9483L104.593 107.942C103.38 112.672 106.226 117.491 110.954 118.713Z",
			fill: "#5C65A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.824 59.1055L175.496 69.3174C176.215 69.5185 176.968 69.1277 177.217 68.4237C177.444 67.7023 177.045 66.9334 176.323 66.7063C176.301 66.699 176.277 66.6923 176.253 66.6856L135.87 56.2906C134.239 57.1169 134.668 58.8082 135.825 59.1055H135.824Z",
			fill: "#404772"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M134.033 66.064L173.704 76.2759C174.424 76.477 175.177 76.0862 175.426 75.3815C175.654 74.6608 175.253 73.8919 174.533 73.6642C174.509 73.6568 174.486 73.6501 174.462 73.6441L134.079 63.2492C132.448 64.0754 132.877 65.7661 134.034 66.064H134.033Z",
			fill: "#404772"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M181.261 82.4454L193.369 85.5622C194.192 85.7733 195.031 85.2776 195.244 84.4547L198.921 70.1675C199.132 69.3438 198.637 68.5055 197.814 68.2925L185.706 65.1757C184.883 64.9653 184.045 65.4603 183.832 66.2832L180.154 80.5711C179.943 81.394 180.438 82.233 181.261 82.4454Z",
			fill: "#5C65A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130.481 80.3413L191.027 95.9271C191.746 96.1275 192.498 95.7367 192.748 95.0327C192.975 94.3119 192.576 93.5431 191.855 93.3153C191.831 93.308 191.808 93.3013 191.784 93.2953L130.526 77.5265C128.895 78.3528 129.324 80.0434 130.481 80.3413Z",
			fill: "#404772"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M128.689 87.3022L189.235 102.887C189.955 103.088 190.707 102.698 190.956 101.994C191.184 101.272 190.784 100.503 190.063 100.276C190.04 100.269 190.016 100.262 189.992 100.256L128.735 84.4873C127.103 85.3136 127.532 87.0042 128.689 87.3022Z",
			fill: "#404772"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M126.899 94.2587L187.445 109.844C188.164 110.045 188.917 109.654 189.166 108.949C189.394 108.229 188.994 107.46 188.273 107.233C188.249 107.225 188.226 107.219 188.202 107.212L126.944 91.4432C125.313 92.2702 125.742 93.9608 126.899 94.2587Z",
			fill: "#404772"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M125.107 101.218L185.652 116.804C186.372 117.005 187.125 116.614 187.374 115.909C187.602 115.189 187.201 114.42 186.481 114.193C186.457 114.185 186.434 114.178 186.41 114.172L125.152 98.4032C123.521 99.2301 123.95 100.921 125.107 101.218Z",
			fill: "#404772"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M123.317 108.175L183.863 123.761C184.582 123.961 185.335 123.571 185.584 122.867C185.812 122.146 185.411 121.377 184.691 121.149C184.667 121.142 184.644 121.135 184.62 121.129L123.362 105.36C121.731 106.187 122.16 107.877 123.317 108.175Z",
			fill: "#404772"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M187.787 172.196C187.567 172.254 187.334 172.238 187.125 172.151L187.111 172.145L184.358 170.978C183.821 170.751 183.57 170.133 183.796 169.596C184.023 169.058 184.642 168.807 185.179 169.033C185.181 169.034 185.183 169.035 185.184 169.035L186.968 169.794L189.306 164.295C189.534 163.759 190.154 163.509 190.69 163.737H190.69L190.676 163.773L190.691 163.737C191.227 163.965 191.476 164.585 191.249 165.121L188.499 171.587C188.369 171.889 188.106 172.114 187.788 172.195L187.787 172.196Z",
			fill: "#252941"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9037 241.914H152.144C161.622 241.903 169.303 234.222 169.314 224.743V67.0888C169.303 57.6103 161.622 49.9293 152.144 49.9186H27.2553L0.733398 71.0585V224.743C0.744153 234.222 8.42516 241.903 17.9037 241.914Z",
			fill: "#404772"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.144 54.8617C158.894 54.869 164.364 60.339 164.372 67.0889V224.743C164.364 231.493 158.894 236.963 152.144 236.971H17.904C11.1541 236.963 5.68411 231.493 5.67676 224.743V73.44L28.9849 54.8617H152.144Z",
			fill: "#373D62"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.0136 100.703H105.132C106.711 100.702 107.989 99.42 107.988 97.8409C107.986 96.2645 106.708 94.9866 105.132 94.9846H44.0136C42.4345 94.9826 41.1527 96.2618 41.1514 97.8409C41.1494 99.42 42.4285 100.702 44.0076 100.703C44.0096 100.703 44.0116 100.703 44.0136 100.703Z",
			fill: "#7985D2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.219 110.354H105.131C106.71 110.354 107.99 109.074 107.99 107.495C107.99 105.915 106.71 104.635 105.131 104.635H32.219C30.6399 104.635 29.3594 105.915 29.3594 107.495C29.3594 109.074 30.6399 110.354 32.219 110.354Z",
			fill: "#7985D2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.0138 138.23H105.129C106.708 138.228 107.99 139.506 107.992 141.085C107.994 142.664 106.716 143.946 105.137 143.948C105.134 143.948 105.132 143.948 105.129 143.948H44.0138C42.4347 143.946 41.1562 142.664 41.1582 141.085C41.1602 139.51 42.4374 138.232 44.0138 138.23Z",
			fill: "#5C65A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.2179 147.882H105.129C106.708 147.88 107.99 149.158 107.992 150.737C107.994 152.316 106.716 153.598 105.137 153.6C105.134 153.6 105.132 153.6 105.129 153.6H32.2179C30.6388 153.598 29.3603 152.316 29.3623 150.737C29.365 149.161 30.6421 147.884 32.2179 147.882Z",
			fill: "#5C65A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.0136 187.197H105.132C106.711 187.195 107.989 185.914 107.988 184.335C107.986 182.758 106.708 181.48 105.132 181.479H44.0136C42.4345 181.477 41.1527 182.756 41.1514 184.335C41.1494 185.914 42.4285 187.195 44.0076 187.197C44.0096 187.197 44.0116 187.197 44.0136 187.197Z",
			fill: "#5C65A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.219 196.848H105.131C106.71 196.848 107.99 195.567 107.99 193.988C107.99 192.409 106.71 191.129 105.131 191.129H32.219C30.6399 191.129 29.3594 192.409 29.3594 193.988C29.3594 195.567 30.6399 196.848 32.219 196.848Z",
			fill: "#5C65A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130.583 92.5632C125.001 92.5632 120.477 97.0874 120.477 102.669C120.477 108.251 125.001 112.775 130.583 112.775C136.164 112.775 140.689 108.251 140.689 102.669C140.689 97.0874 136.164 92.5632 130.583 92.5632Z",
			fill: "#7985D2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M129.681 106.524C129.454 106.524 129.233 106.451 129.05 106.315L129.039 106.306L126.664 104.489C126.201 104.135 126.113 103.472 126.467 103.01C126.821 102.547 127.484 102.458 127.947 102.813C127.947 102.813 127.948 102.814 127.949 102.814L129.487 103.993L133.122 99.2509C133.477 98.7886 134.139 98.7011 134.601 99.0558H134.602L134.579 99.0872L134.602 99.0558C135.064 99.4112 135.151 100.073 134.797 100.535L130.522 106.111C130.321 106.371 130.011 106.524 129.682 106.523L129.681 106.524Z",
			fill: "#9FA8DF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M119.438 145.915C119.435 151.497 123.958 156.023 129.539 156.025C129.541 156.025 129.541 156.025 129.542 156.025C129.629 156.027 129.716 156.023 129.802 156.015C135.381 155.872 139.789 151.233 139.645 145.653C139.502 140.074 134.863 135.667 129.284 135.81C123.805 135.951 119.436 140.434 119.438 145.915Z",
			fill: "#5C65A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130.583 179.057C125.001 179.057 120.477 183.582 120.477 189.163C120.477 194.745 125.001 199.269 130.583 199.269C136.164 199.269 140.689 194.745 140.689 189.163C140.689 183.582 136.164 179.057 130.583 179.057Z",
			fill: "#5C65A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M74.8014 153.6H105.137C106.716 153.598 107.994 152.316 107.992 150.737C107.99 149.158 106.708 147.88 105.129 147.882H75.0964C74.7885 149.771 74.6895 151.689 74.8014 153.6Z",
			fill: "#7985D2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.0571 143.948H105.137C106.716 143.946 107.994 142.664 107.992 141.085C107.99 139.506 106.708 138.227 105.129 138.23H78.7521C77.61 140.037 76.7108 141.96 76.0571 143.948Z",
			fill: "#7985D2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M122.738 138.441C120.707 140.292 119.436 142.958 119.437 145.915C119.436 150.391 122.344 154.188 126.374 155.518C127.152 149.696 125.959 143.641 122.738 138.441Z",
			fill: "#7985D2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.24995 71.7383H22.0253C25.1835 71.7383 27.7438 69.1779 27.7438 66.0198V50.6751C27.7438 50.4781 27.5842 50.3178 27.3865 50.3178C27.3063 50.3178 27.2282 50.3451 27.1647 50.3952L1.02805 71.101C0.873346 71.2233 0.847297 71.4484 0.969803 71.6027C1.0376 71.6882 1.1408 71.7383 1.24995 71.7383Z",
			fill: "#5C65A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.2384 214.847C32.8383 216.616 35.5705 216.754 37.3401 215.154L81.1421 175.556C82.9126 173.956 83.0496 171.224 81.4494 169.454C79.8493 167.683 77.1173 167.546 75.3477 169.146L31.5457 208.744C29.7752 210.344 29.6373 213.077 31.2384 214.847Z",
			fill: "#9FA8DF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M119.91 134.684C129.512 145.305 128.685 161.698 118.065 171.299C107.445 180.9 91.0517 180.074 81.4502 169.453C71.8495 158.833 72.6753 142.44 83.2962 132.839C93.9221 123.254 110.302 124.08 119.91 134.684ZM75.0402 175.249C87.8417 189.409 109.699 190.51 123.86 177.709C138.021 164.908 139.122 143.051 126.321 128.89C113.519 114.729 91.6616 113.627 77.5009 126.429C63.3618 139.241 62.2605 161.08 75.0402 175.249Z",
			fill: "#9FA8DF"
		})
	]
});
export default SvgNotSelected;
